module.exports = "/images/vendor/flag-icon-css/flags/1x1/gp.svg?c2c4da0e6afbe97dffaa2ee25972ae72";